<!--
 * @Deccription:
 * @Author: zjg
 * @Date: 2020-03-04 16:15:58
 * @LastEditTime: 2020-03-04 16:19:38
 * 基础的弹框提示组件
 -->
<template>
  <div
    id="ld-content"
    class="ld-normal"
  >
    <div class="ld-normal-content">
      <div class="normal-header clear-float">
        <svg class="warn-icon">
          <use xlink:href="#warn" />
        </svg>
        <div
          id="ld-header"
          class="color-section"
        >
          {{ $t(headerContent) }}
        </div>
      </div>
      <div
        v-if="tipsComponent"
        id="ld-tips"
        class="color-tips"
      >
        <component
          :is="tipsComponent"
          :error-data="errorData"
        />
      </div>
      <div
        v-else
        id="ld-tips"
        class="color-tips"
      >
        {{ $t(headerTips) }}
      </div>
    </div>
    <div
      id="ld-operation"
      class="normal-footer"
    >
      <button
        v-if="btnCancelContent"
        class="primary file-download ld-double s-btn"
        @click="btnClickHandler('cancel')"
      >
        {{ $t(btnCancelContent) }}
      </button>
      <button
        v-if="btnSureContent"
        class="primary file-download ld-single s-btn"
        @click="btnClickHandler('sure')"
      >
        {{ $t(btnSureContent) }}
      </button>
    </div>
  </div>
</template>
<script>
// import { logout, fileDetailDialog } from 'js/mixin/ldtool/dialog-data.js'=================
// import ldtoolFileType from './ldtool-file-type.vue'
import { downloadWebTool } from 'js/ldTool'
export default {
  components: {
    // ldtoolFileType
  },
  props: {
    // 不同组件的数据元素
    // type: 'sizeLimit',
    // otherData: metadata
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      download_url: 'about:blank',
      errorData: {
        info: {
          doc_type: '.doc',
        },
      },
      // 弹框内容配置
      dialogCfg: {
        sizeLimit: {
          btns: [{
            content: '下载',
            func: 'download',
          }],
          title: '文件大小超出上限',
          header: '本地编辑文件大小上限200MB',
          tips: '为了更好的编辑体验，请您下载后在进行编辑',
        },
        sessionOccupied: {
          btns: [{
            content: '重试',
            func: 'retry',
          }],
          title: '提示',
          header: 'zBox WebTool被占用',
          tips: '当前计算机上的zBox WebTool已被占用，请先关闭任务，再重试',
        },
        transmitLogout: {
          btns: [{
            content: '取消',
            func: 'cancel',
          }, {
            content: '继续退出',
            func: 'exit',
          }],
          title: 'zBox WebTool正在运行',
          header: 'zBox WebTool有正在传输的任务，是否要退出？',
          tips: '',
        },
        editLogout: {
          btns: [{
            content: '查看文件',
            func: 'viewFile',
          }, {
            content: '继续退出',
            func: 'exit',
          }],
          title: 'zBox WebTool正在运行',
          header: '有文件正在编辑中，继续退出可能会导致文件内容丢失',
          tips: '请关闭文件等待自动保存完成后退出',
        },
        noUseableTool: {
          btns: [{
            content: '重试',
            func: 'retry',
          }],
          title: '提示',
          header: '未检测到可打开该文件的应用程序',
          tips: '',
          component: 'ldtool-file-type',
        },
        upgradeWebtool: {
          btns: [
            {
              content: '下载',
              func: 'downloadWebTool',
            },
          ],
          title: '提示',
          header: 'WebTool不是最新版本，请下载最新版本后重试',
          tips: '',
        },

      },
    }
  },
  computed: {
    headerContent() {
      return this.getNormalData(this.data.type).header || ''
    },
    tipsComponent() {
      return this.getNormalData(this.data.type).component
    },
    headerTips() {
      return this.getNormalData(this.data.type).tips
    },
    btnSureContent() {
      let text = ''
      if (this.getNormalData(this.data.type).btns
                && this.getNormalData(this.data.type).btns[0]) {
        text = this.getNormalData(this.data.type).btns[0].content || ''
      }
      return text
    },
    btnSureFunc() {
      let func
      if (this.getNormalData(this.data.type).btns
                && this.getNormalData(this.data.type).btns[0]) {
        func = this.getNormalData(this.data.type).btns[0].func
      }
      return func
    },
    btnCancelContent() {
      let text = ''
      if (this.getNormalData(this.data.type).btns
                && this.getNormalData(this.data.type).btns[1]) {
        text = this.getNormalData(this.data.type).btns[1].content || ''
      }
      return text
    },
    btnCancelFunc() {
      let func
      if (this.getNormalData(this.data.type).btns
                && this.getNormalData(this.data.type).btns[1]) {
        func = this.getNormalData(this.data.type).btns[1].func
      }
      return func
    },
  },
  methods: {
    test(func, data) {
      this[func].call(this, data)
    },
    btnClickHandler(type) {
      if (type === 'sure') {
        this[this.btnSureFunc] && this[this.btnSureFunc]()
      } else if (type === 'cancel') {
        this[this.btnCancelFunc] && this[this.btnCancelFunc]()
        this.$emit('closeParentDialog')
      }
    },
    // 取消
    cancel() {
      this.$emit('closeParentDialog')
    },
    // 下载
    download() {
      this.$download(this.data.metaData)
    },
    // 重试
    retry() {
      this.$emit('retry')
      this.$emit('closeParentDialog')
    },
    // 查看文件
    viewFile() {
      // let data = this.data.otherData==================
      // fileDetailDialog(data)
    },
    // 继续退出
    exit() {
      // logout()=======================
    },
    // 获取弹框数据
    getNormalData(type) {
      return this.dialogCfg[type] || {}
    },
    downloadWebTool() {
      downloadWebTool()
    },
  },
}
</script>
<style lang="less">
@import '~less/ldtool-dialog.less';
</style>
